export const organizationUserRolesReadOnly = [
  {
    text: 'Співробітник',
    value: 'ROLE_ACCOUNTANT'
  },
  {
    text: 'Адміністратор',
    value: 'ROLE_ADMINISTRATOR'
  },
  {
    text: 'Власник',
    value: 'ROLE_OWNER'
  },
  {
    text: 'Головний бухгалтер',
    value: 'ROLE_HEAD_ACCOUNTANT'
  }
]

export const organizationUserRolesUkMap = {
  ROLE_ACCOUNTANT: 'Співробітник',
  ROLE_ADMINISTRATOR: 'Адміністратор',
  ROLE_OWNER: 'Власник',
  ROLE_HEAD_ACCOUNTANT: 'Головний бухгалтер'
}

export const statuses = [
  {
    text: 'Активний',
    value: 'active'
  },
  {
    text: 'Очікується',
    value: 'awaiting'
  }
]

export const organizationUserStatusesUkMap = {
  active: 'Активний',
  awaiting: 'Очікується'
}

export const organizationUsersStatuses = [
  {
    value: 'awaiting',
    text: 'Очікується',
    background: 'rgba(255, 170, 1, 0.08)',
    color: '#FFAA01'
  },
  {
    value: 'active',
    text: 'Активний',
    background: 'rgba(33, 150, 83, 0.08)',
    color: '#219653'
  }
]
